var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1543 0.410156H22.0801C23.6044 0.410156 24.8398 1.64561 24.8398 3.16992V22.0957C24.8398 23.62 23.6044 24.8555 22.0801 24.8555H3.1543C1.62999 24.8555 0.394531 23.62 0.394531 22.0957V3.16992C0.394531 1.64561 1.62999 0.410156 3.1543 0.410156Z",
    fill: "white",
    stroke: "#405189",
    strokeWidth: 0.788574
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.068 17.5703H7.17787C6.95457 17.5703 6.76562 17.7593 6.76562 17.9826C6.76562 18.2059 6.95457 18.3948 7.17787 18.3948H18.068C18.2913 18.3948 18.4802 18.2059 18.4802 17.9826C18.4802 17.7593 18.2913 17.5703 18.068 17.5703ZM6.7828 13.9632L6.76562 15.9042C6.76562 16.0072 6.79998 16.1275 6.88586 16.1962C6.97175 16.2649 7.07481 16.3164 7.17787 16.3164L9.11886 16.2993C9.22192 16.2993 9.32498 16.2477 9.41086 16.179L16.0755 9.51439C16.2301 9.3598 16.2301 9.08497 16.0755 8.93038L14.1517 7.00657C13.9971 6.85198 13.7223 6.85198 13.5677 7.00657L12.2279 8.34636L6.90304 13.6712C6.81716 13.7571 6.7828 13.8601 6.7828 13.9632ZM15.1995 9.22238L14.4437 9.97817L13.1039 8.63837L13.8597 7.88259L15.1995 9.22238ZM7.60729 14.135L12.5199 9.22238L13.8597 10.5622L8.94709 15.4748H7.60729V14.135Z",
    fill: "#405189"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d423d4ad77226ab7fc7db304b8cd0f48.svg";
export { ForwardRef as ReactComponent };